import { UserIdReq } from '@analytics-soa/shared-models';
import { Body, Controller, Post } from '@nestjs/common';
import { ClientConfigurationsService } from './client-configurations.service';

@Controller('client-configurations')
export class ClientConfigurationsController {
    constructor(private readonly clientConfigurationsService: ClientConfigurationsService) { }

    @Post('findAllDivisions')
    async findAllDivisions() {
        return await this.clientConfigurationsService.findAllDivisions();
    }

    @Post('getDivisionForUserId')
    async getDivisionForUserId(@Body() req:any) {
        try {
            return await this.clientConfigurationsService.getDivisionForUserId(req)
        } catch (error) {
            return error
        }
    }
}